export default __webpack_public_path__ + "static/media/HC.93a527ac.png";